module.exports = __webpack_public_path__ + "static/20-05269b5d3e0ff3002564bff4a97e297f.jpg";